/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './role-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {RoleApiService, RoleModel} from './role-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-role-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoleListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.roles.role';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'application'},
    {param: 'scope'},
    {param: 'description'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<RoleModel>(
    inject(RoleApiService),
    {listId: 'fullRoleList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
